interface FetchArgs {
  url: string
  data: unknown
  headers?: Record<string, string>
}

/**
 * Fetch JSON for the given URL
 *
 * @param url - URL to fetch
 * @returns Promise resolving with JSON from the request
 */
export function fetchJSON(url: string): Promise<unknown> {
  return fetch(url, {
    mode: 'cors',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  }).then(res => res.json() as Promise<unknown>)
}

/**
 * Fetch Response for the given URL
 *
 * @param url - URL to fetch
 * @returns Promise resolving with the Response from the request
 * @throws Error when the response status is not OK
 */
export function ampFetch(url: string): Promise<Response> {
  return window.fetch(url).then(response => {
    if (!response.ok) {
      throw new Error(response.statusText)
    }
    return response
  })
}

/**
 * Fetch POST data to the given URL
 *
 * @example
 * postDataToService({ url: '/email/api', data: {} })
 *
 * @param args - Object with url, data to post, and optional headers
 * @returns Promise resolving with the parsed JSON response
 */
export function postDataToService(args: FetchArgs): Promise<unknown> {
  let headers: Record<string, string> = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
  if (args.headers) {
    headers = {
      ...headers,
      ...args.headers
    }
  }
  return fetch(args.url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(args.data)
  }).then(response => {
    return response.json() as Promise<unknown>
  })
}
